/** @jsxImportSource @emotion/react */
import { forwardRef } from 'react';

const NavLi = forwardRef(({ as: Comp, page, className = '', ...props }, ref) => {
	return <li ref={ref} className={className} {...props} />;
});

export default NavLi;
